<template>
    <div class="about-au">
        <p class="indent">Alcomet AD is a Bulgarian leader in the production of flat-rolled and
          extruded aluminium products, with over 40 years history. The plant
          incorporates the entire downstream production cycle from billetand
          coil-casting through extrusion and cold-rolling to prefabricated
          components on a single manufacturing site in Shumen, Bulgaria. Its
          production facilities equipped with high-end technological solutions
          have a total capacity of 100 thousand tons per year.</p>

        <p class="indent">For the last 20 years, Alcomet has invested over 155 mln. EUR in
          equipment modernization, sustainable manufacturing processes,
          focusing on the reduction of carbon emissions and improved recycling
          rates. The most extensive investment programme to date completed
          in 2020 and involved major capacity expansion in both main production
          divisions through the acquisition of a new 25 MN HybrEx® extrusion
          press and 6-high cold-rolling mill. In the beginning of 2021 the
          company has launched its new workshop, dedicated to mechanical
          processing of aluminium profiles into finished products for the
          automotive industry.</p>

      <p class="indent" style="text-align:center;">
        <img v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/v1.jpg" alt="">
      </p>
      <p class="indent" style="text-align:center;">
        <img v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/au/v2.jpg" alt="">
      </p>


      <p class="indent">Alcomet has a strong presence in the European and US market,
          serving the Building and Construction, Automotive, Transportation,
          Packaging, Engineering and Distribution sectors.</p>
        <div class="about-au-img">
            <img v-scroll-reveal.reset src="/static/img/about/au/1.jpg" alt="">
            <img v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/2.jpg" alt="">
            <img v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/au/3.jpg" alt="">
            <p v-scroll-reveal.reset="{ delay: 750 }" class="about-au-img-p">Today Alcomet ranks among the top 100 Bulgarian companies in terms of income and growth. It is also among the top 100 biggest employers in Bulgaria.</p>
        </div>
        <p class="indent">Alcomet is certified to ISO 9001, ISO 14001, ISO 45001, EN 15088,
          IATF 16949, QUALANOD, QUALICOAT, and it is strongly engaged
          in programmes effectively addressing the issues of environmental
          protection, waste reduction and resource efficiency. Continuous
          investment in modern technologies and equipment guarantees
          product improvement and sustainable development of the company.</p>
        <iframe width="560" height="500" src="https://www.youtube.com/embed/kOaJrBzodvg" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-au p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-au-img {
  align-items: center;
  display: flex;
  margin: 40px auto;
  position: relative;
  width: 80%;
  padding-right: 10%;
}
.about-au-img img {
  border-radius: 6px;
  height: auto;
  margin-left: 22px;
  width: calc(33.33% - 22px);
}
.about-au img:last-child {
  padding-right: 0;
}
.about-au-img-p {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  font-size: 24px;
  font-weight: 700;
  height: 170px;
  justify-content: center !important;
  text-align: center !important;
  padding: 20px 20px 20px 60px;
  position: absolute;
  right: 0;
  top: calc(50% - 85px);
}
iframe {
  display: block;
  margin: 0 auto;
  width: 60%;
}
@media screen and (max-width: 1280px) {
  .about-au .about-au-img-p {
    font-size: 16px;
  }
}
@media screen and (max-width: 1000px) {
  .about-au p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-au-img {
    flex-wrap: wrap;
    margin-bottom: 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-au-img img {
    margin-left: 20px;
    width: calc(33.33% - 13.33px);
  }
  .about-au-img img:first-child {
    margin-left: 0;
  }
  .about-au .about-au-img-p {
    font-size: 12px;
    font-weight: 500;
    height: initial;
    line-height: 20px;
    position: static;
    top: initial;
  }
  iframe {
    width: 100%;
    padding: 10px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/AboutUs.vue